<template lang="pug">
  article
    .u-child-view-wrapper
      transition(name="u-child-view" mode="out-in")
        router-view(@page-navbar="receiveNavbar" @loading="receiveLoading")
</template>

<script>
import {defineComponent, ref} from "vue";

export default defineComponent({
  emits: ['page-navbar', 'loading'],
  setup(_, { emit }) {
    const isNavbar = ref(false)
    const loading = ref(false)

    const receiveNavbar = (value) => {
      isNavbar.value = value;
      emit('page-navbar', value);
    }
    const receiveLoading = (isLoading) => {
      loading.value = isLoading;
      emit('loading', isLoading);
    }

    return { receiveNavbar, receiveLoading }
  }
})
</script>
